/**
 * COURE.HUB.DS.SMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UserChannelTypeEnum } from './userChannelTypeEnum';

export interface MessageDto { 
    originatingNo?: string;
    destinationNo?: string;
    referenceNo?: string;
    senderId?: string;
    messageId?: string;
    messageContent?: string;
    dateCreated?: Date;
    userChannelType?: UserChannelTypeEnum;
}